"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  fin: {
    //关账日期
    accountCloseDateManage: '关账日期维护',
    reCordcompany: '公司名称',
    yearAndMonth: '年月',
    confirmDate: '确认时间',
    closeAccountDate: '关账时间',
    confirm: '确定',
    cancelConfirm: '取消确定',
    financeManagement: '财务管理',
    fuelStockManagement: '燃油库存管理',
    fuelStockQuantity: '燃油库存余额管理',
    fuelStockFlow: '燃油库存流水',
    fuelStockAccount: '燃油库存流水管理',
    financialReport: '财务报表',
    fuelStockStat: '燃油进销存量',
    shipCharteringStat: '船舶租入情况统计',
    shipRentingStat: '船舶租出情况统计（期租、光租）',
    shipRentingVcStat: '船舶租出情况统计（程租）',
    voyageCostBill: '航次成本账单归集情况',
    commenceGmt: '航次开始时间',
    completeGmt: '航次结束时间',
    monthlyFuelReconciliation: '月度燃油期末对账表',
    monthlyShipBenefits: '月度船舶效益统计表',
    voyageEndTime: '航次结束时间',
    flowTime: '流水时间',
    laidUpTime: '入库时间',
    reportTime: '上报时间',
    operationNo: '操作号',
    batchNo: '批次号',
    unitPrice: '单价',
    bunkerSpec: '油种',
    leftQuantity: '库存量',
    amountMoney: '金额',
    trendAmount: '动态金额',
    laidUpVoyageNo: '入库航次号',
    stockStatus: '签收入库状态',
    fuelQuantity: '油量',
    trendFuelPrice: '价格',
    stockOperate: '动态动作',
    trendFuelQuantity: '燃油动态量',
    tonOfNumber: '数量（吨）',
    closeBalance: '期末结存',
    trendDate: '动态日期',
    businessDate: '业务日期',
    avgPrice: '期末平均价格',
    terminalStockAmount: '期末库存金额',
    universalOrderNumber: '万能单号',
    auditStatus: '审核状态',
    auditDate: '审核日期',
    voucherNo: '凭证号',
    openFuelStorage: '期初存油',
    closeFuelStorage: '期末存油',
    closeBatchAmount: '期末金额',
    treadNumber: '动态量',
    openQuantity: '期初量',
    dynamicQuantity: '动态油量',
    endQuantity: '期末量',
    endStockQuantity: '期末存油',
    beginAmount: '期初金额',
    fuelSequenceManage: '燃油序时管理',
    fuleMonthlyManage: '月度燃油库存管理',
    sequence: '序时',
    fuelDealStatus: '燃油处理状态',
    previousOperation: '上一序时操作',
    previousOpreationTime: '上一序时操作时间',
    sequenceDetail: '序时明细',
    fuelQuantityDetail: '燃油现有量明细',
    fourBunkerQuantity: '油种油量(4个)',
    operationTime: '操作时间',
    laidUpOperationNo: '入库操作号',
    detailType: '动态明细动作',
    currency: '币种',
    refuelType: '加油类型',
    company: '经营公司',
    stockDetail: '库存明细',
    //数据监控
    dataMonitor: '数据监控',
    universalManagement: '万能单管理',
    register: '登记',
    localCheck: '待本地核查',
    sending: '发送队列中',
    sendSuccess: ' 发送成功（会计引擎待审）',
    sendError: '发送失败',
    localAdjust: '仅本地调整',
    writeOffSuccess: '冲销成功',
    writeOffFail: '冲销失败',
    discard: '废弃',
    batchGenerateUniversal: '批量生成万能单',
    oriOrderCode: '原单编码',
    account: '账套',
    accountMonth: '会计月',
    dataTime: '数据时间',
    operator: '姓名',
    scene: '场景',
    abstract: '摘要',
    baseCurrencyAmount: '本位币金额',
    redOffsetOrder: '是否红冲单',
    status: '状态',
    supplier: '供应商',
    orderNo: '定单号',
    variety: '费用科目',
    direction: '借贷方向',
    debitEntry: '借方科目',
    debitEntryName: '借方科目名称',
    creditEntry: '贷方科目',
    creditEntryName: '贷方科目名称',
    oriCurrencyAmount: '原币金额',
    noTaxAmount: '不含税金额(原币)',
    exTaxAtion: '含税金额(原币)',
    exchangeRate: '汇率',
    entriesAbstract: '分录摘要',
    companyPropertyCode: '公司产权码',
    sendStatus: '发送状态',
    lastDataDate: '最后数据日期',
    specialInstrucion: '特殊说明',
    entriesDetail: '分录明细',
    intelligentLoad: '智能载入',
    accountDetail: '核算明细',
    accountType: '核算项目类型',
    accountTypeName: '核算项目类型名称',
    accountProjectCode: '核算项目编码',
    accountProjectName: '核算项目名称',
    inOutRecords: '出入库记录',
    isControlled: '是否受控',
    orderSource: '来源定单',
    businessSubject: '业务科目',
    materialName: '物资名称',
    inOutType: '出入库类型',
    inOutDate: '出入库日期',
    orderUnitPrice: '定单单价',
    vesselCode: '船舶代码',
    vesselName: '船舶名称',
    interfaceType: '接口类型',
    //暂估
    refreshReport: "刷新报告",
    refreshReportAll: "刷新所有",
    refreshReportVsl: "刷新船舶",
    refreshReportVoy: "刷新航次",
    refreshReportTc: "刷新期租",
    checkShip: "租船月前检查",
    monthEstimateManage: '月结管理',
    shipEstimateManage: '租船暂估管理',
    generateVoyageEstimate: '生成航次暂估',
    generate: '生成',
    vcEstimate: '程租暂估',
    tcEstimate: '期租暂估',
    voyageInfo: '航次信息',
    preCompany: '编制公司',
    reportType: '报告类型',
    reportNo: '报表编号',
    preDept: '编制部门',
    checkOutDate: '结账日(GMT+0)',
    mainBusiness: '主营业务',
    voyageTotalTime: '航次总时间',
    establishmentDate: '成立时间',
    deliveryDate: '交船时间',
    redeliveryDate: '还船时间',
    businessType: '业务类型',
    voyageType: '航次类型',
    personStatistic: '个性统计',
    cargo: '货种',
    cargoQuantity: '货量',
    feeItem: '费用项目',
    routeName: '航线名称',
    voyageCurrency: '航次币种',
    exportTime: '导出时间',
    pocEstimate: 'POC暂估',
    noInvoiceEstimate: '未来票暂估',
    portCharge: '港口使费',
    voyageIncidental: '航次杂费',
    portIncidental: '港口使费/杂费',
    bunkerFee: '燃油费',
    income: '收入',
    cost: '支出',
    reportAmount: '报告金额',
    pocAmount: 'POC金额',
    thisMonthEstimateAmount: '当月暂估数',
    estimateReceiptNo: '暂估万能单号',
    freightDemurrage: '运费/滞期费',
    contractInvoice: '运费/滞期费合同发票',
    charterer: '租家',
    invoiceType: '发票类型',
    invoiceAmount: '发票金额',
    incomeReceiptNo: '收入确认万能单号',
    thisMonthWriteOffAmount: '本月冲销金额',
    recepitNumber: '万能单数',
    //orderNo: '订单号',
    feeType: '费用类型',
    portName: '港口名称',
    oriCurrency: '原币',
    orderAmount: '订单金额',
    invoiceIsAll: '发票是否来齐',
    invoiceNo: '发票号',
    supplierCode: '供应商编码',
    costQuantity: '消耗量',
    bunkerCostAmount: '耗油金额',
    pocOriCurrency: 'POC本币',
    pocTax: 'POC税额',
    paymentAmount: '应付单金额',
    previousPocAmount: '上期POC金额',
    previousPocTax: '上期POC税额',
    thisMonthOriCurrencyAmount: '当月本币数',
    oilSupplier: '油商及编号',
    financeDataCompare: '财务数据比对',
    diffNumber: '差异数',
    businessData: '业务数据',
    financeData: '财务数据',
    vesselSource: '船舶来源',
    generateReceipt: '生成万能单',
    parentSubjectName: '上级科目名称',
    feeSubjectCode: '费用科目代码',
    feeSubjectName: '费用科目名称',
    feeSubjectNameEn: '费用科目英文名称',
    enterBusinessCode: '请传入业务场景代码！',
    enterDeptInfo: '请传入部门信息！',
    previousRecoilAmount: '上月冲回金额',
    laidUpStartTime: '开始时间',
    laidUpEndTime: '结束时间',
    universalDetail: '万能单明细',
    estimatePortFee: '预估使费',
    actualPortFee: '实际使费',
    invoiceDate: '发票日期',
    createTime: '创建日期',
    receiptWriteOff: '万能单冲销',
    writeOff: '冲销',
    needConfirmAmount: '应确认收入金额',
    isNeedConfirm: '是否需要确认收入',
    confirmReceiptStatus: '收入确认万能单状态',
    confirmReceiptAmount: '收入确认万能单金额',
    isNeedEstiamte: '是否需要暂估',
    estimateReceiptStatus: '暂估万能单状态',
    estimateReceiptAmount: '万能单暂估金额',
    receiptErrorMessage: '万能单生成失败原因',
    //期租暂估
    rentEstimate: '租金暂估',
    rentInvoice: '租金发票',
    deliveryReturnFuel: '交还船燃油库存',
    deliveryInfo: '交船信息(交船时间(UTC))',
    returnInfo: '还船信息(还船时间(UTC))',
    refuelInfo: '加油信息',
    period: '期数',
    thisMonthInvoiceNo: '当期发票号',
    rentDateStart: '租金日期从',
    rentDateEnd: '租金日期到',
    IsLastPeriod: '是否最后一期',
    closeDate: '关账日期',
    rentType: '租金类型',
    dayRent: '日租金',
    returnCommission: '回佣',
    commission: '佣金',
    days: '天数',
    type: '类型',
    rentAmount: '租金金额',
    cveAmount: 'CVE金额',
    returnCommissionAmount: '回佣金额',
    commissionAmount: '佣金金额',
    totalAmount: '总金额',
    receiptAmount: '万能单金额',
    rentIncome: '租金收入',
    totalInvoiceAmount: '发票总金额',
    deliveryReceiptNo: '交船万能单号',
    returnReceiptNo: '还船万能单号',
    checkQuantity: '校正油量',
    checkUnitPrice: '校正单价',
    checkAmount: '校正金额',
    checkDeliveryReceipt: '交船校正万能单号',
    checkReturnReceipt: '还船校正万能单号',
    refuelDate: '加油时间',
    refuelQuantity: '加油油量',
    refuelReceiptNo: '加油签收万能单号',
    belongDate: '所属年月',
    estimateType: '暂估类型',
    estimateVersion: '暂估版本',
    dataStatus: '数据状态',
    refreshDate: '暂估单刷新时间',
    orderDealDate: '单据处理时间',
    errorOrderNo: '异常单据号',
    receiptGenerateStatus: '万能单生成状态',
    receiptSendStatus: '万能单发送状态',
    deliveryVoyageNo: '交船航次号',
    newestRentInvoice: '最新租金发票',
    newestRentStart: '最新租期开始',
    newestRentEnd: '最新租期结束',
    contractExecuteStatus: '合同执行状态',
    contractCurrencyCode: '合同币种',
    dayRentAmount: '日均金额',
    needEstimateAmount: '应暂估金额',
    engineAuditPass: '引擎审核通过',
    engineAuditReturn: '引擎审核退回',
    estimateNo: '暂估编号',
    //月结航次检查
    companyCode: '公司编码',
    checkBeforeChartMonth: '租船月结前检查',
    insuranceEstimate: '保险暂估',
    insuranceDetail: '保险暂估明细',
    generateVirtual: '生成虚拟协议',
    generateUniversal: '生成万能单',
    offsetUniversal: '万能单冲销',
    reportExists: '记录已存在',
    reportNotExists: '没有符合条件的船舶保险协议',
    month: '月份',
    companyName: '公司',
    involvedMonthShips: '参与月结船舶数',
    involvedMonthVoyages: '参与月结航次数',
    voyagesCheckPassed: '航次检查通过数',
    estimatesGenerated: '航次提交财务数',
    reportCreationTime: '报告创建时间',
    reportUpdateTime: '报告更新时间',
    generateReports: '生成报告',
    generateEstimate: '生成暂估',
    submitFinance: '提交财务',
    shipPlausibilityInspection: '船舶营运情况检查',
    voyageBusinessInspection: '航次业务检查',
    reportInspection: '报告检查',
    fuelinspection: '燃油检查',
    portFeeInspection: '港杂费检查',
    auditor: '负责人',
    shipStatus: '船舶状态',
    latestVoyageStatus: '最新航次状态',
    latestVoyageTime: '最新航次时间段',
    latestVoyageTimeBegin: '最新航次开始时间',
    latestVoyageTimeEnd: '最新航次结束时间',
    retirementTime: '退役时间',
    yesOrNoCheck: '是否检查通过',
    cause: '原因',
    voyageCheckStatus: '航次检查是否通过',
    vesselCheck: '船舶检查是否通过',
    tcCheckStatus: '期租检查是否通过',
    notPassReasons: '不通过原因',
    voyageCheckRefreshTime: '航次检查刷新时间',
    yesOrNoGenerated: '是否已生成暂估',
    buildDate: '生成时间',
    monthEndReason: '参与月结原因',
    estimateAmount: '成本未来齐金额',
    detailsPage: '详情页',
    allChoice: '全选',
    allPassedChoice: '勾选检查通过',
    allPassedChoice0: '勾选检查通过未生成',
    allNotPassedChoice: '勾选检查不通过',
    dataFrom: '数据来源',
    loadingTime: '装货时间',
    lastInvoiceTime: '收支最新更新时间',
    reportStatus: '航次预/结算检查是否通过',
    voyageStatus: '航次状态',
    reportSource: '暂估来源',
    completionTime: '装货完成时间',
    latestReportAuditTime: '最新报告创建时间',
    reportNotPassResons: '报告不通过原因',
    fuelStatus: '燃油检查是否通过',
    fuelNotPassResons: '燃油不通过原因',
    portOtherFeeStatus: '港杂费检查是否通过',
    portOtherFeeNotPassResons: '港杂费不通过原因',
    estimateGenerateReason: '暂估生成失败原因',
    checkType: "检查类型",
    failReason: "失败原因",
    isWriteOff: "红冲状态",
    //分录明细
    handleDate: '日期',
    writeOffId: '红冲编码',
    accountDate: '会计期间',
    remark: '特殊说明',
    selectOne: '请选择记录',
    generateEstimateFail: '提交财务失败',
    generateEstimateSuccess: '提交财务成功',
    generateEstimateResult: '成功：{0}，失败：{1}',
    executeFail: '执行失败',
    executeSuccess: '执行成功',
    executeResult: '成功：{0}，失败：{1}',
    // 期租检查
    timeCharterInspection: '期租检查',
    vesselName2: '船舶',
    voyageNo: '航次号',
    companyNameCn: '经营公司',
    contractNo: '合同号',
    chartererName: '租家',
    contractType: '期租类型',
    participateReason: '参与月结原因',
    actDelTime: '交船时间',
    actRedTime: '还船时间',
    estimateGenerateFlag: '是否已生成暂估',
    estimateGenerateDate: '暂估生成时间',
    lastestInvoiceNo: '最新一期发票号',
    lastestInvoiceDate: '最新一期发票时间',
    finalFlag: '发票是否最后一期',
    periodFrom: '租金日期起',
    periodTo: '租金日期止',
    submitFlag: '发票递交情况',
    // 财务暂估
    ispFleetName: '经营公司',
    statisticalMonth: '统计月份',
    insYear: '保险年度',
    hmCount: 'H&M Premium协议份数',
    ivCount: 'I&V Premium协议份数',
    warCount: 'WAR Premium协议份数',
    piCount: 'P&I Call协议份数',
    fddCount: 'FDD Call协议份数',
    invoicedCount: '已来发票协议数',
    completeCount: '发票来齐协议数',
    universalCount: '已生成万能单数',
    // 财务暂估明细
    insureType: '保险类型',
    insurerName: '保险商',
    brokerName: '经纪人',
    isSigned: '是否已签订协议',
    startDate: '协议开始时间',
    endDate: '协议结束时间',
    amount: '协议金额',
    brokerAmount: '经纪人佣金',
    invoiceComplete: '发票是否来齐',
    invoiceCompleteNum: '发票已来期数',
    insFlag: '协议数/发票数',
    monthCost: '本月已进保费成本',
    estimateCost: '本月应进保费成本',
    offsetCost: '本月暂估保费成本',
    receiptNo: '万能单号',
    receiptStatus: '万能单发送状态',
    selectVirtual: '请选择虚拟协议',
    selectReceiptNull: '请选择未生成万能单记录',
    selectReceiptNotNull: '请选择万能单号不为空的记录',
    cancelReceipt: '是否确认冲销万能单：',
    generateFlag: '是否生成(冲销)成功',
    generateReason: '生成(冲销)失败原因',
    checkPassSelectVC: '请选择航次检查通过的记录',
    checkPassSelectTC: '请选择期租检查通过的记录',
    //航次数据更新
    voyageDataUpdate: '航次数据更新',
    thisPeriodRedShow: '本期值红色显示',
    payApplicationDate: '收付款审核日期',
    batchApprove: '批量审核',
    batchUpdate: '批量更新',
    previousDate: '上期数据日期',
    thisDate: '本期数据日期',
    previoueRevenue: '上期总收入',
    thisRevenue: '本期总收入',
    previousExpense: '上期总支出',
    thisExpense: '本期总支出',
    previousDayTce: '上期日均TCE',
    thisDayTce: '本期日均TCE',
    dataUpdateError: '更新失败原因'
  }
};